import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableProps,
  TableRow,
  Typography,
} from "@mui/material";
import I18n from "i18n";
import React from "react";
import { JsonValue } from "./JsonValue";

type ChangeItem = {
  id: string;
  old: unknown;
  new: unknown;
};

type HistoryChangesProps = TableProps & {
  value?: ChangeItem[];
  id?: string;
  objectName?: string;
  label?: string;
  event?: string;
};

const cellSx = { verticalAlign: "top", fontSize: 13 };

const EVENT_LABELS: Record<string, string> = {
  deleted: "Rekord törölve.",
  restored: "Rekord visszaállítva.",
};

export const HistoryChanges: React.FC<HistoryChangesProps> = ({
  value,
  objectName,
  event,
  label,
  id,
  ...tableProps
}) => {
  if (event && EVENT_LABELS[event]) {
    return (
      <Typography variant="body2" color="text.secondary" fontStyle="italic">
        {EVENT_LABELS[event]}
      </Typography>
    );
  }

  if (!value?.length) return null;

  const isCreated = event === "created";

  return (
    <TableContainer>
      <Table size="small" {...tableProps}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, fontSize: 13 }}>Mező</TableCell>
            {!isCreated && (
              <TableCell
                sx={{ fontWeight: 700, fontSize: 13, color: "error.main" }}
              >
                Régi érték
              </TableCell>
            )}
            <TableCell
              sx={{ fontWeight: 700, fontSize: 13, color: "success.main" }}
            >
              Új érték
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {value.map((item, index) => {
            const label =
              item.id === "id"
                ? "ID"
                : I18n.t(`${objectName}.attributes.${item.id}`, {
                    defaultValue: item?.id,
                  }) || item.id;

            return (
              <TableRow key={item.id + index}>
                <TableCell sx={{ ...cellSx, fontWeight: 600 }}>
                  {label}
                </TableCell>
                {!isCreated && (
                  <TableCell sx={cellSx}>
                    <JsonValue
                      value={item.old}
                      comparisonValue={item.new}
                      diffSide="old"
                    />
                  </TableCell>
                )}
                <TableCell sx={cellSx}>
                  <JsonValue
                    value={item.new}
                    comparisonValue={item.old}
                    diffSide={isCreated ? undefined : "new"}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
